import { createApp, defineAsyncComponent } from 'vue'
import { createPinia, setActivePinia } from 'pinia'
import App from './App.vue'
import router from './router'
import {
    initializeCampaignManagerMf,
    initializePlayerManagerMf,
    initializeHiveManagerMf,
    initializeFileManagerMf,
    initializeNotificationManagerMf,
    initializeUserManagerMf
} from './util/mfInitialization'
import { api, auth, Environment, resourceUserManager } from 'auth-package'
import { useAuth } from 'auth-package'
import i18n from './i18n'
import ElementPlus from 'element-plus'
import en from 'element-plus/es/locale/lang/en'
import 'uilibrary/lib/style.css'
import 'auth-package/lib/style.css'
import './assets/main.scss'

const app = createApp(App)

app.use(i18n)

const appEnv = __APP_ENV__ ?? "default";
let apiEnv = Environment.Develop;

if (appEnv == "local" || appEnv == "develop" || appEnv == "default") {

    app.use(auth, {
        url: 'https://keycloak.develop.prizific.com',
        realm: 'debug-realm',
        clientId: 'auth-login',
        resourceServer: ''
    })
} else if (appEnv == "prod") {
    apiEnv = Environment.Prod;
    app.use(auth, {
        url: 'https://auth.prizific.com',
        realm: 'admin',
        clientId: 'admin-login',
        resourceServer: ''
    })
}


app.use(api, {
    environment: apiEnv,
})

const pinia = createPinia()

app.use(resourceUserManager, { $pinia: pinia });

app.use(pinia)


app.use(ElementPlus, {
    locale: en
})

app.use(router)


useAuth()
    .init()
    .then(async () => {
        await Promise.all([
            initializeCampaignManagerMf({
                app: app,
                pinia: pinia,
                router: router,
                i18n: i18n
            }),
            initializePlayerManagerMf({
                app: app,
                pinia: pinia,
                router: router,
                i18n: i18n
            }),
            initializeHiveManagerMf({
                app: app,
                pinia: pinia,
                router: router,
                i18n: i18n
            }),
            initializeFileManagerMf({
                app: app,
                pinia: pinia,
                router: router,
                i18n: i18n
            }),
            initializeUserManagerMf({
                app: app,
                pinia: pinia,
                router: router,
                i18n: i18n
            }),
            initializeNotificationManagerMf({
                app: app,
                pinia: pinia,
                router: router,
                i18n: i18n
            })
        ]).catch((error) => {
            console.log('Error loading federated modules', error)
        });

        app.mount('#app')

        await router.replace(router.currentRoute.value.fullPath)
    })
    .catch((e: any) => {
        //TODO: add error page
        console.log('Errr', e)
    })
